<template>
  <div class="panelSwiper">
    <swiper
      v-if="showSwiper"
      :autoplay="swiperOptions.autoplay"
      :loop="swiperOptions.loop"
      :speed="swiperOptions.speed"
      :pagination="swiperOptions.pagination"
    >
      <swiper-slide v-for="(news, index) of this.newsList" :key="index">
        <a class="swiper-slide" :href="news.href" target="_blank">
          <img :src="news.img" />
        </a>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { reactive } from "vue";
// 引入Swiper及子模块
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Autoplay, Pagination } from "swiper";
// import "swiper/swiper.min.css";
// import "swiper/components/pagination/pagination.min.css";
SwiperCore.use([Autoplay, Pagination]);
// 引入请求类
import { getIndexTopPicNews } from "../../server/index_top_pic_news";

export default {
  data() {
    return {
      newsList: [],
    };
  },
  mounted() {
    this.fetchTopPicNews();
  },
  methods: {
    async fetchTopPicNews() {
      let result = await getIndexTopPicNews();
      this.newsList = result;
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const swiperOptions = reactive({
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      loop: true,
      speed: 1000,
      pagination: {
        clickable: true,
      },
    });
    return {
      swiperOptions,
    };
  },
  computed: {
    showSwiper() {
      return this.newsList.length;
    }
  }
};
</script>

<style>
.panelSwiper {
  width: 1000px;
  height: 440px;
  display: inline-block;
}

.panelSwiper .swiper-slide {
  display: block;
  width: 1000px;
  height: 440px;
}

.panelSwiper .swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
}

.swiper-pagination {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 20px;
  z-index: 9999;
  text-align: center;
}

.panelSwiper .swiper-pagination-bullet {
  width: 26px;
  height: 6px;
  display: inline-block;
  border-radius: 3px;
  background-color: rgba(255, 255, 255, 0.5);
  margin-right: 6px;
  transition: all 0.4s;
}

.panelSwiper .swiper-pagination-bullet-active {
  width: 40px;
  height: 6px;
  border-radius: 3px;
  background-color: #fff;
}
</style>